module.exports = __webpack_public_path__ + "img/TipperRoof_Overview.1abf84a7.jpg";